import { JobApplicationCvDataInput, JobApplicationExperienceInput } from '../../../graphql/generated';
import { CvData } from '../types';

type CvDataObject = JobApplicationCvDataInput | JobApplicationExperienceInput;

const newCvDataKeys = {
  overallExperience: 'sectorExperience',
  careerStage: 'workExperience',
  education: 'education',
  position: 'subject',
  employer: 'center',
  degree: 'subject',
  institution: 'center',
  startDate: 'from',
  endDate: 'to',
};

export const getParsedCvData = (formFieldValues: CvData): JobApplicationCvDataInput => {
  const createNewCvDataObj = (cvDataObj) => {
    return <CvDataObject>Object.entries(cvDataObj).reduce((newCvDataObj, [key, value]) => {
      if (newCvDataKeys[key] !== undefined) {
        const newKey = newCvDataKeys[key];

        if (value !== null && typeof value === 'object') {
          value = createNewCvDataObj(value);
        }

        newCvDataObj[newKey] = value;
      }

      return newCvDataObj;
    }, {});
  };

  const jobApplicationCvDataInput = <JobApplicationCvDataInput>createNewCvDataObj(formFieldValues);

  if (jobApplicationCvDataInput.sectorExperience === '0') {
    jobApplicationCvDataInput.workExperience = null;
  }

  if (!!jobApplicationCvDataInput.workExperience && formFieldValues.careerStage.isPresentEndDate) {
    jobApplicationCvDataInput.workExperience.to = null;
  }

  if (formFieldValues.education.isPresentEndDate) {
    jobApplicationCvDataInput.education.to = null;
  }

  return jobApplicationCvDataInput;
};
